var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"label",attrs:{"for":_vm.inputId}},[_c('span',[_vm._v(_vm._s(_vm.text))]),(_vm.note)?_c('span',{staticClass:"note"},[_vm._v("("+_vm._s(_vm.note)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }